import React from 'react';
// template components
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export default () => (
  <SectionContainer
    id='northwestern-mutual-subsidaries'
    disableBottomPadding>
    <Row align='center'>
      <Col
        medium={8}>
        <Typography
          component='h1'
          align='center'
          nextElement='typography'>
          Northwestern Mutual Subsidaries
        </Typography>
        <Typography nextElement='typography'>
          For more than 160 years, people have been able to rely on Northwestern Mutual to provide them with access to a wide variety of products and services. We have a history of performance and an enviable reputation.
        </Typography>
        <Typography disableBottomPadding>
          Through our subsidiaries, we can provide you with a full range of financial services and dynamic solutions.
        </Typography>
        <BulletedList
          bulletType='filledCircle'
          bulletedListData={[
            {
              bulletText: (
                <Typography disableBottomPadding>
                  <strong>Mason Street Advisors, LLC,</strong> SEC&#45;registered investment advisor for Northwestern Mutual Series Fund variable annuity and variable life products
                </Typography>
              ),
            },
            {
              bulletText: (
                <Typography disableBottomPadding>
                  <strong>Northwestern Long Term Care Insurance Company,</strong> long&#45;term care insurance
                </Typography>
              ),
            },
            {
              bulletText: (
                <Typography disableBottomPadding>
                  <strong>Northwestern Mutual Investment Management Company, LLC</strong> manages Northwestern Mutual&#39;s investments in publicly traded debt and equity securities, privately placed debt and equity securities, interests in private equity funds, mortgage loans and real estate equity.
                </Typography>
              ),
            },
            {
              bulletText: (
                <Typography disableBottomPadding>
                  <strong>Northwestern Mutual Investment Services, LLC,</strong> broker&#45;dealer, investment advisor, member FINRA and SIPC
                </Typography>
              ),
            },
            {
              bulletText: (
                <Typography disableBottomPadding>
                  <strong>Northwestern Mutual Wealth Management Company,</strong> financial planning, investment advisory and trust services
                </Typography>
              ),
            },
          ]}
        />
      </Col>
    </Row>
  </SectionContainer>
);
